const districtEventTypeCatalog = {
  'fotobox-fuer-hochzeit-mieten': {
    slug: 'fotobox-fuer-hochzeit-mieten',
    name: 'Hochzeit',
    icon: '💒',
    description: 'Perfekt für stilvolle Hochzeiten mit persönlichem Layout und Sofortdruck.'
  },
  'fotobox-fuer-geburtstag-mieten': {
    slug: 'fotobox-fuer-geburtstag-mieten',
    name: 'Geburtstag',
    icon: '🎂',
    description: 'Flexibel für private Feiern mit spontanen Erinnerungsfotos.'
  },
  'fotobox-fuer-firmenfeier-mieten': {
    slug: 'fotobox-fuer-firmenfeier-mieten',
    name: 'Firmenfeier',
    icon: '🏢',
    description: 'Professionell für Business-Events, Sommerfeste und Teamabende.'
  },
  'fotobox-fuer-jugendweihe-mieten': {
    slug: 'fotobox-fuer-jugendweihe-mieten',
    name: 'Jugendweihe',
    icon: '🎓',
    description: 'Einfach planbar für Familienfeiern mit vielen Gästen und Ausdrucken.'
  },
  'fotobox-fuer-abiball-mieten': {
    slug: 'fotobox-fuer-abiball-mieten',
    name: 'Abiball',
    icon: '🎓',
    description: 'Perfekt für Schulabschlussfeiern und unvergessliche Gruppenfotos.'
  },
  'fotobox-fuer-einschulung-mieten': {
    slug: 'fotobox-fuer-einschulung-mieten',
    name: 'Einschulung',
    icon: '🎒',
    description: 'Wunderschöne Erinnerungen an den ersten großen Schultag.'
  },
  'fotobox-fuer-konfirmation-mieten': {
    slug: 'fotobox-fuer-konfirmation-mieten',
    name: 'Konfirmation',
    icon: '⛪',
    description: 'Ideal für Familienfeiern mit persönlichen Erinnerungsfotos.'
  },
  'fotobox-fuer-kommunion-mieten': {
    slug: 'fotobox-fuer-kommunion-mieten',
    name: 'Kommunion',
    icon: '🙏',
    description: 'Stilvolle Erinnerungen für diesen besonderen Anlass.'
  },
  'fotobox-fuer-babyshower-mieten': {
    slug: 'fotobox-fuer-babyshower-mieten',
    name: 'Babyshower',
    icon: '🍼',
    description: 'Liebevolle Momente für werdende Eltern und Freunde.'
  },
  'fotobox-fuer-kindergeburtstag-mieten': {
    slug: 'fotobox-fuer-kindergeburtstag-mieten',
    name: 'Kindergeburtstag',
    icon: '🎈',
    description: 'Spassige Erinnerungen mit Accessoires und Sofortdruck.'
  },
  'fotobox-fuer-weihnachtsfeier-mieten': {
    slug: 'fotobox-fuer-weihnachtsfeier-mieten',
    name: 'Weihnachtsfeier',
    icon: '🎄',
    description: 'Perfekt für Firmen und private Weihnachtsfeiern.'
  },
  'fotobox-fuer-sommerfest-mieten': {
    slug: 'fotobox-fuer-sommerfest-mieten',
    name: 'Sommerfest',
    icon: '☀️',
    description: 'Locker für Outdoor-Events und entspannte Feiern.'
  },
  'fotobox-fuer-messe-mieten': {
    slug: 'fotobox-fuer-messe-mieten',
    name: 'Messe',
    icon: '🎪',
    description: 'Ideal für Leadgenerierung und Branding auf Events.'
  },
  'fotobox-fuer-vereinsfeier-mieten': {
    slug: 'fotobox-fuer-vereinsfeier-mieten',
    name: 'Vereinsfeier',
    icon: '🏆',
    description: 'Perfekt für Vereinsjubiläen und gemeinsame Erinnerungen.'
  },
  'fotobox-fuer-polterabend-mieten': {
    slug: 'fotobox-fuer-polterabend-mieten',
    name: 'Polterabend',
    icon: '🥂',
    description: 'Ausgelassene Stimmung und lustige Erinnerungsfotos.'
  }
}

export const districtEventTypePresets = {
  berlin: [
    'fotobox-fuer-hochzeit-mieten',
    'fotobox-fuer-geburtstag-mieten',
    'fotobox-fuer-firmenfeier-mieten',
    'fotobox-fuer-jugendweihe-mieten',
    'fotobox-fuer-abiball-mieten',
    'fotobox-fuer-einschulung-mieten',
    'fotobox-fuer-konfirmation-mieten',
    'fotobox-fuer-kommunion-mieten',
    'fotobox-fuer-babyshower-mieten',
    'fotobox-fuer-kindergeburtstag-mieten',
    'fotobox-fuer-weihnachtsfeier-mieten',
    'fotobox-fuer-sommerfest-mieten',
    'fotobox-fuer-messe-mieten',
    'fotobox-fuer-vereinsfeier-mieten',
    'fotobox-fuer-polterabend-mieten'
  ],
  brandenburg: [
    'fotobox-fuer-hochzeit-mieten',
    'fotobox-fuer-geburtstag-mieten',
    'fotobox-fuer-firmenfeier-mieten',
    'fotobox-fuer-jugendweihe-mieten',
    'fotobox-fuer-abiball-mieten',
    'fotobox-fuer-einschulung-mieten',
    'fotobox-fuer-konfirmation-mieten',
    'fotobox-fuer-kommunion-mieten',
    'fotobox-fuer-babyshower-mieten',
    'fotobox-fuer-kindergeburtstag-mieten',
    'fotobox-fuer-weihnachtsfeier-mieten',
    'fotobox-fuer-sommerfest-mieten',
    'fotobox-fuer-messe-mieten',
    'fotobox-fuer-vereinsfeier-mieten',
    'fotobox-fuer-polterabend-mieten'
  ]
}

export function getDistrictEventTypes(presetName) {
  const preset = districtEventTypePresets[presetName] || []

  return preset
    .map((slug) => districtEventTypeCatalog[slug])
    .filter(Boolean)
}

export { districtEventTypeCatalog }
